import type { MetaFunction } from 'react-router'
import { Link } from 'react-router'
import { STATIC_PAGE_HEADERS } from '~/lib/cache.server'
import { Navbar } from '~/components/navbar'
import { Footer } from '~/components/footer'

export function headers() { return STATIC_PAGE_HEADERS }

export const meta: MetaFunction = () => [
  { title: "Droit d'opposition — AfficheServices" },
  { name: 'description', content: "Exercez votre droit d'opposition RGPD : refusez le traitement de vos données personnelles par AfficheServices." },
  { name: 'robots', content: 'noindex,follow' },
  { tagName: 'link', rel: 'canonical', href: 'https://www.afficheservices.fr/droit-opposition' },
]

export default function DroitOpposition() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="mx-auto max-w-3xl px-4 py-16 lg:px-6">
        <h1 className="text-3xl font-bold text-slate-900">Droit d'opposition</h1>
        <p className="mt-2 text-sm text-slate-500">Conformité RGPD — Article 21 du Règlement (UE) 2016/679</p>

        <article className="prose prose-slate mt-8 max-w-none text-sm leading-relaxed">
          <h2>Votre droit d'opposition</h2>
          <p>
            L'article 21 du RGPD vous confère le droit de vous opposer, à tout moment et pour des raisons
            tenant à votre situation particulière, à un traitement de vos données personnelles fondé sur
            l'intérêt légitime du responsable de traitement.
          </p>

          <h2>Traitements concernés</h2>
          <p>Vous pouvez vous opposer aux traitements suivants :</p>
          <ul>
            <li><strong>Prospection commerciale :</strong> emails de présentation de services, newsletters, offres partenaires. Droit d'opposition absolu et sans motif.</li>
            <li><strong>Profilage :</strong> personnalisation des résultats de recherche ou des recommandations d'artisans.</li>
            <li><strong>Statistiques et analytics :</strong> collecte de données de navigation à des fins d'amélioration du service (hors cookies strictement nécessaires).</li>
          </ul>

          <h2>Traitements non opposables</h2>
          <p>
            Certains traitements sont fondés sur l'exécution du contrat (mise en relation avec les artisans,
            gestion de votre compte) ou sur une obligation légale (facturation, conservation fiscale).
            Ils ne peuvent pas faire l'objet d'une opposition — mais vous pouvez demander la suppression
            de votre compte, ce qui met fin aux traitements contractuels.
          </p>

          <h2>Comment exercer votre droit</h2>

          <h3>Opposition à la prospection commerciale</h3>
          <p>
            Cliquez sur le lien de désinscription présent en bas de chaque email commercial, ou envoyez
            un email à{' '}
            <a href="mailto:rgpd@afficheservices.fr" className="text-primary">rgpd@afficheservices.fr</a>
            {' '}avec l'objet « Opposition prospection ». Prise en compte immédiate.
          </p>

          <h3>Opposition aux analytics</h3>
          <p>
            Refusez les cookies non essentiels via notre bandeau de consentement (accessible à tout moment
            via le lien « Gérer les cookies » en pied de page). Vous pouvez également activer le signal
            « Do Not Track » de votre navigateur, que nous respectons.
          </p>

          <h3>Opposition générale</h3>
          <p>
            Pour toute autre opposition, envoyez votre demande motivée à{' '}
            <a href="mailto:rgpd@afficheservices.fr" className="text-primary">rgpd@afficheservices.fr</a>.
            Joignez une copie de votre pièce d'identité. Réponse sous 30 jours.
          </p>

          <h2>Conséquences de l'opposition</h2>
          <p>
            Si vous vous opposez à un traitement fondé sur l'intérêt légitime, nous cesserons le
            traitement sauf si nous démontrons des motifs légitimes et impérieux qui prévalent sur
            vos droits (article 21.1 RGPD). Pour la prospection, l'opposition est toujours effective
            et sans condition.
          </p>

          <h2>Liens utiles</h2>
          <ul>
            <li><Link to="/droit-acces" className="text-primary hover:underline">Droit d'accès</Link></li>
            <li><Link to="/violation-donnees" className="text-primary hover:underline">Notification de violation</Link></li>
            <li><Link to="/confidentialite" className="text-primary hover:underline">Politique de confidentialité</Link></li>
            <li><a href="https://www.cnil.fr/vos-droits" target="_blank" rel="noreferrer" className="text-primary hover:underline">Vos droits sur cnil.fr</a></li>
          </ul>
        </article>
      </div>
      <Footer />
    </div>
  )
}
